import React, { useEffect, useState } from 'react'
import { Typography, withStyles, CircularProgress } from '@material-ui/core'
import { Selections, FileUpload } from '..'
import { CoreButton, CoreTextField } from 'src/components/core'
import styles from './styles'
import { useHistory, useLocation } from 'react-router-dom'
import {
  llmGetChatMessagesSuccess,
  llmSetChatId,
  llmGetTranslatedContentAction,
} from 'src/reducers/llm/action'
import { useDispatch, useSelector } from 'react-redux'
import CountrySelect from 'src/components/language-selection'
import { track } from '@amplitude/analytics-browser'

const UseMyResourceWithAIChat = props => {
  const { classes, cardSelection } = props
  const dispatch = useDispatch()
  const history = useHistory()
  const [creationType, setCreationType] = useState(0)
  const [description, setDescription] = useState('')
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const collectionId = searchParams.get('collectionId')
  const chatId = useSelector(state => state.llmContent.chatId)
  const attachments = useSelector(state => state.llmContent.attachments)
  const [attachmentLoading, setAttachmentLoading] = useState(false)
  const [loading, setLoading] = useState(false)
  const attachmentsToCheck = attachments.filter(
    attachment => attachment.succeeded === false,
  )
  const placeholder = 'What should be the title?'

  useEffect(() => {
    const inputBase = document.getElementById('title-input')
    if (inputBase) {
      inputBase.focus()
    }
  }, [])

  const handleChatRedirect = () => {
    track('started_building_course')
    setLoading(true)
    if (attachments.length == 0) {
      dispatch(llmSetChatId())
      dispatch(
        llmGetChatMessagesSuccess({
          chatId: null,
          messages: [],
          attachments: [],
        }),
      )
    }
    const courseType = creationType === 0 ? 'course' : 'quiz'

    dispatch(
      llmGetTranslatedContentAction(
        description,
        languageSelection.countryCode,
        courseType,
        response => {
          setLoading(false)
          if (cardSelection === 1) {
            history.push(
              `/create-course-with-chat?collectionId=${collectionId}&message=${response}`,
            )
          } else {
            history.push(
              `/create-course-with-chat?collectionId=${collectionId}&chatId=${chatId}&message=${response}`,
            )
          }
        },
      ),
    )
  }
  const languageOptions = window.CONSTANTS.LANGUAGES
  const [languageSelection, setLanguageSelection] = React.useState(
    languageOptions.find(x => x.countryCode === 'en'),
  )
  return (
    <div className={classes.container}>
      <Typography className={classes.cardTitle}>
        {cardSelection === 1
          ? 'Select the type & enter the details'
          : 'Upload your resource and let the AI proceed based on it'}
      </Typography>

      {cardSelection === 2 && (
        <FileUpload
          attachmentLoading={attachmentLoading}
          setAttachmentLoading={setAttachmentLoading}
        />
      )}

      <Selections
        creationType={creationType}
        setCreationType={setCreationType}
      />

      <CoreTextField
        id="title-input"
        multiline
        value={description}
        onChange={e => setDescription(e.target.value)}
        variant="outlined"
        fullWidth
        label={placeholder}
        marginTop={true}
      />
      <CountrySelect
        languageSelection={languageSelection}
        setLanguageSelection={setLanguageSelection}
        label="Output Language"
      />
      <div className={classes.buttonContainer}>
        {loading ? (
          <CircularProgress />
        ) : (
          <CoreButton
            disabled={
              description.length === 0 ||
              (cardSelection == 2 && attachments.length == 0) ||
              attachmentsToCheck.length != 0
            }
            onClick={handleChatRedirect}
            fullWidth
          >
            Start building
          </CoreButton>
        )}
      </div>
    </div>
  )
}

export default withStyles(styles)(UseMyResourceWithAIChat)
